<template>
  <div class="moblie_box">
    <div
      :class="isSelect == 1 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(1)"
    >
      <i class="iconfont icon-kehu"></i
      ><router-link class="moblie_link" to="/MyWriter">我的写手</router-link>
    </div>
    <div
      :class="isSelect == 2 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(2)"
    >
      <i class="iconfont icon-wp-sj"></i
      ><router-link class="moblie_link" to="/OrderCenter">接单中心</router-link>
    </div>
    <div
      :class="isSelect == 3 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(3)"
    >
      <i class="iconfont icon-wp-sj"></i
      ><router-link class="moblie_link" to="/WriterBookInfo"
        >写手书籍信息</router-link
      >
    </div>
    <div
      :class="isSelect == 4 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(4)"
    >
      <i class="iconfont icon-gonghaiguanli"></i
      ><router-link class="moblie_link" to="/WriterHighSeas"
        >写手公海信息</router-link
      >
    </div>
    <div
      :class="isSelect == 5 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(5)"
    >
      <i class="iconfont icon-kehuchazhong"></i
      ><router-link class="moblie_link" to="/UploadManuscript"
        >每日上传稿件</router-link
      >
    </div>
    <div
      :class="isSelect == 6 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(6)"
    >
      <i class="iconfont icon-kehuchazhong"></i
      ><router-link class="moblie_link" to="/ManuscriptManage"
        >稿费预支及暂压稿</router-link
      >
    </div>
    <div
      :class="isSelect == 7 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(7)"
    >
      <i class="iconfont icon-kehuchazhong"></i
      ><router-link class="moblie_link" to="/ManuscriptAdvance"
        >稿费预支申请记录</router-link
      >
    </div>
    <div
      :class="isSelect == 8 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(8)"
    >
      <i class="iconfont icon-kehuchazhong"></i
      ><router-link class="moblie_link" to="/ManuscriptTemporary"
        >暂压稿费申请记录</router-link
      >
    </div>
    <div
      :class="isSelect == 9 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(9)"
    >
      <i class="iconfont icon-chuyuanjiesuan"></i>
      <router-link class="moblie_link" to="/writerFeeExpenditure"
        >其余费用支出</router-link
      >
    </div>
    <div
      :class="isSelect == 10 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(10)"
    >
      <i class="iconfont icon-chuyuanjiesuan"></i>
      <router-link class="moblie_link" to="/writerFeeIncome"
        >其余费用收入</router-link
      >
    </div>
    <div
      :class="isSelect == 11 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(11)"
    >
      <i class="iconfont icon-chuyuanjiesuan"></i>
      <router-link class="moblie_link" to="/ManuscriptDeposit"
        >压稿管理</router-link
      >
    </div>
    <div
      :class="isSelect == 12 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(12)"
    >
      <i class="iconfont icon-jilu"></i>
      <router-link class="moblie_link" to="/UploadFileRecord"
        >文件上传记录</router-link
      >
    </div>
    <div
      :class="isSelect == 13 ? 'select_menu_item ' : 'mobile_menu_item'"
      @click="handleMenuItem(13)"
    >
      <i class="iconfont icon-chuyuanjiesuan"></i>
      <router-link class="moblie_link" to="/writerCheaterPool"
        >骗子库</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isSelect: 0 //是否选择菜单项 0 ：是  1： 否
    };
  },
  methods: {
    handleMenuItem(val) {
      this.isSelect = val;
    }
  }
};
</script>
<style scoped>
.mobile_menu_item {
  color: #000;
  font-size: 10px;
}
.mobile_menu_item:hover,
.mobile_menu_item .moblie_link:hover {
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 0px;
}
.select_menu_item {
  text-align: left;
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;

  padding: 5px 0px;
}
.mobile_menu_item i {
  margin-left: 40%;
}
.moblie_link {
  text-decoration: none;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileOwnerData.vue